var map = {
	"./adobexd-grey.svg": "77ac",
	"./adobexd.svg": "9cf2",
	"./crafted-grey.svg": "0cfb4",
	"./figma-grey.svg": "9173",
	"./figma.svg": "170a",
	"./github-brands.svg": "9035",
	"./high-resolution-grey.svg": "9696",
	"./product-hunt-logo.svg": "79d9",
	"./simple-grey.svg": "966d",
	"./sketch-brands.svg": "b526",
	"./sketch-grey.svg": "f9e3",
	"./twitter-brands.svg": "8134",
	"./unsplash_logo_full.svg": "6cd3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";